import React, { useState } from 'react';
import { CLIENT_CUSTOM_FEATURE_EDIT } from 'src/constants/EndpointUrls';
import { concatParamsToUrl } from 'src/utils/Http';

import DetailModal from './DetailModal';

const ClientListShowTable = ({ client, customFeatures }) => {
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [currentFeature, setCurrentFeature] = useState(null);

  const onRowSelection = record => {
    setIsModalOpen(true);
    setCurrentFeature(record);
  };

  const handleCancelModal = () => {
    setIsModalOpen(false);
    setCurrentFeature(null);
  };

  return (
    <>
      <div className="custom-feature-table">
        <table className="table table-hover">
          <thead>
            <tr>
              <th>Feature name</th>
              <th>Status</th>
              <th>Type</th>
              <th>Option</th>
              <th>Condition</th>
              <th>Value</th>
              <th>Detail</th>
              <th />
            </tr>
          </thead>
          <tbody>
            {customFeatures.length > 0 ? (
              customFeatures.map(feature => (
                <tr key={feature.id}>
                  <td>
                    <span>{feature.nameEn ? feature.nameEn : feature.nameTh}</span>
                  </td>
                  <td>
                    <span className={`badge badge-${feature.status === 'using' ? 'success' : 'danger'}`}>
                      {feature.status}
                    </span>
                  </td>
                  <td>{feature.featureType}</td>
                  <td>{feature.option}</td>
                  <td>{feature.condition}</td>
                  <td>{feature.value}</td>
                  <td>
                    <button onClick={() => onRowSelection(feature)} className="btn btn-primary">
                      Detail
                    </button>
                  </td>
                  <td>
                    <a
                      href={concatParamsToUrl(CLIENT_CUSTOM_FEATURE_EDIT, {
                        client_id: client.id,
                        client_custom_feature_id: feature.id
                      })}
                      className="btn btn-outline-dark"
                    >
                      Edit
                    </a>
                  </td>
                </tr>
              ))
            ) : (
              <tr>
                <td align="center" colSpan={8}>
                  No data
                </td>
              </tr>
            )}
          </tbody>
        </table>
      </div>
      <DetailModal title="Detail" isOpen={isModalOpen} onCancel={handleCancelModal} currentFeature={currentFeature} />
    </>
  );
};

export default ClientListShowTable;
